/**
 * @module FleetTabs
 * @description Tab bar for Fleet Manager — renders dynamic tabs derived from lane deployment stages.
 * Each tab shows a badge count of non-ISS lanes in that stage.
 * Tabs scroll horizontally when there are too many to fit the viewport.
 */
import React from 'react';

function FleetTabs({ activeTab, onTabSwitch, tabCounts, stages }) {
  return (
    <div className="fleet-tabs">
      {stages.map(stage => (
        <button
          key={stage.key}
          className={`fleet-tab ${activeTab === stage.key ? 'fleet-tab-active' : ''}`}
          style={{ '--tab-color': stage.color }}
          onClick={() => onTabSwitch(stage.key)}
        >
          {stage.label} <span className="fleet-tab-count">{tabCounts[stage.key] || 0}</span>
        </button>
      ))}
    </div>
  );
}

export default FleetTabs;
